import ObjectUtils, { coalesce, normalizeQuillLists } from "../../../../utils/ObjectUtils";

import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";
import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import { useIntl } from "react-intl";
import QuestionValidation from "./QuestionValidation";

const { getDeepProperty } = ObjectUtils;

/**
 * The component which represents header for every question which is rendered in survey view/runner.
 * It contains title, description  and validation for question.
 */
const QuestionHeader = ({ question, children, answered, validation, showOnlyError, initialTextLength }) => {
  const intl = useIntl();
  const emptyColumnNameFilter = (validator) => coalesce(validator.columnName, "").length === 0;
  const emptyColumnRowNameFilter = (validator) =>
    coalesce(validator.columnName, "").length === 0 && coalesce(validator.rowName, "").length === 0;

  const qValidators = coalesce(getDeepProperty(question, "validators"), []).filter(emptyColumnNameFilter);
  const qValidations = coalesce(validation, []).filter(emptyColumnRowNameFilter);
  const validator = getDeepProperty(qValidators, 0);
  const qValidation = getDeepProperty(qValidations, 0);

  let description = normalizeQuillLists(question.description);
  if (description) {
    description = description.replace(/<p><\/p>/g, "<p><br></p>");
  }
  const isCompleted = answered && (!qValidation || (qValidation.lengthNotValid !== true && qValidation.precisionNotValid !== true));
  const incompleteRequiredQuestion = !isCompleted && question.isRequired;
  return (
    // question.title is what user types in input field for title, question.name is unique name for every question
    // which we are using in background requirement is- if there is no title entered for question- it will not be
    // shown in runner

    <>
      {question.title && question.type !== "projectData" && (
        <>
          <div
            className={`h5 question-title ${incompleteRequiredQuestion ? "text-danger" : ""}`}
            role="heading"
            aria-level="5"
          >
            <div
              className="rich-text-title"
              dangerouslySetInnerHTML={{ __html: normalizeQuillLists(question.title) }}
            />
            {question.isRequired && (
              <big className={`${incompleteRequiredQuestion ? "text-danger" : "text-dark"}`} title={intl.formatMessage({ id: "user.surveyView.mandatory.field.tooltip" })}>
                <b> *</b>
              </big>
            )}
            {isCompleted && <FontAwesomeIcon icon={faCheck} className="text-success ms-2" />}
          </div>
        </>
      )}
      {description && <div className="rich-text-content" dangerouslySetInnerHTML={{ __html: description }} />}
      {children}
      <Row>
        {question.type === "number" ? (
          <Col lg={4} md={5} sm={7}>
            <QuestionValidation validation={qValidation} validator={validator} showOnlyError={showOnlyError} />
          </Col>
        ) : question.type === "text" ? (
          <Col lg={4} md={5} sm={7}>
            <QuestionValidation
              validation={qValidation}
              validator={validator}
              showOnlyError={showOnlyError}
              questionType={question.type}
            />
          </Col>
        ) : (
          <Col
            className={question.type === "comment" ? "text-end" : undefined}
            lg={{
              span: 4,
              offset: 8
            }}
            md={{
              span: 5,
              offset: 7
            }}
            sm={{
              span: 7,
              offset: 5
            }}
          >
            <QuestionValidation
              validation={qValidation}
              validator={validator}
              showOnlyError={showOnlyError}
              questionType={question.type}
              initialTextLength={initialTextLength}
            />
          </Col>
        )}
      </Row>
    </>
  );
};

QuestionHeader.propTypes = {
  question: PropTypes.object.isRequired,
  answered: PropTypes.bool.isRequired,
  validation: PropTypes.array,
  showOnlyError: PropTypes.bool,
  initialTextLength: PropTypes.number,
  children: PropTypes.object,
  intl: PropTypes.object
};

export default QuestionHeader;
